/*
 * line-toggle.js — switches the page between product lines without a reload.
 *
 * Sections opt in by rendering snippets/line-group.liquid, which drops a
 * hidden marker carrying data-line-group. CSS in rebrand.css hides whole
 * sections whose marker does not match the active line, via :has(). Sections
 * with no marker are shared and always show.
 *
 * The active line lives in one attribute on <html>, so the hiding is pure CSS
 * and applies before paint - no flash of the wrong line, provided the initial
 * value is written in the <head> (see the inline snippet in the toggle
 * section, which runs before the body renders).
 */
(function () {
  'use strict';

  var ATTR = 'data-active-line';
  var STORE_KEY = 'wr-active-line';
  var PARAM = 'line';

  function normalise(v) {
    return v === 'tonics' || v === 'gummies' ? v : null;
  }

  function readStored() {
    // Browsers can throw on storage access (private mode, blocked cookies).
    try { return normalise(localStorage.getItem(STORE_KEY)); } catch (e) { return null; }
  }

  function store(v) {
    try { localStorage.setItem(STORE_KEY, v); } catch (e) { /* not critical */ }
  }

  function current() {
    return normalise(document.documentElement.getAttribute(ATTR));
  }

  function apply(line, opts) {
    var next = normalise(line);
    if (!next || next === current()) return;
    document.documentElement.setAttribute(ATTR, next);
    store(next);

    // Reflect it in the URL so the choice can be linked to and survives a
    // reload, without adding a history entry per click.
    if (opts && opts.updateUrl && window.history && history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set(PARAM, next);
        history.replaceState(null, '', url);
      } catch (e) { /* older browsers: skip */ }
    }

    syncButtons();
    document.dispatchEvent(new CustomEvent('line:change', { detail: { line: next } }));
  }

  function syncButtons() {
    var active = current();
    var buttons = document.querySelectorAll('[data-line-switch]');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      var isActive = b.getAttribute('data-line-switch') === active;
      b.classList.toggle('plt__option--active', isActive);
      b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    }
  }

  function onClick(e) {
    var btn = e.target.closest ? e.target.closest('[data-line-switch]') : null;
    if (!btn) return;
    e.preventDefault();
    apply(btn.getAttribute('data-line-switch'), { updateUrl: true });
  }

  function init() {
    // Precedence: an explicit ?line= wins, then a remembered choice, then
    // whatever the template set as its default.
    var fromUrl = null;
    try { fromUrl = normalise(new URL(window.location.href).searchParams.get(PARAM)); } catch (e) { /* ignore */ }
    var initial = fromUrl || readStored() || current();
    if (initial) {
      document.documentElement.setAttribute(ATTR, initial);
      if (fromUrl) store(fromUrl);
    }
    syncButtons();
  }

  document.addEventListener('click', onClick);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // The theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', syncButtons);

  window.WillieLineToggle = { set: function (l) { apply(l, { updateUrl: true }); }, get: current };
})();
